module.exports = __webpack_public_path__ + "static/img/Tangga dsk.9c8d4b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Tangga dsk.jpg
// module id = 109
// module chunks = 1